// extracted by mini-css-extract-plugin
export default {"spinner-container":"spinner-container--u2AOf"};